import React from 'react'
import BlogPost from './BlogPost'

function Blogs() {
    return (
        <>
        <h1 id="blogs-h1">Recent Blogs</h1>
        <div className="blogs">
            <div>
                <BlogPost imageLink="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*XBHgSIQnMu9RACjsz-xoSg.png" blogLink="https://medium.com/@jigyasaupadhyay60/frontend-design-system-components-part-1-75f7f60caf94" title="Frontend Design System Components (Part 1)"/>
                <BlogPost imageLink="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*XBHgSIQnMu9RACjsz-xoSg.png" blogLink="https://medium.com/@jigyasaupadhyay60/frontend-design-system-components-part-2-67ad22ff2bea" title="Frontend Design System Components (Part 2)"/>
                <BlogPost imageLink="https://miro.medium.com/v2/resize:fit:1188/format:webp/1*7miMTgvhkiXr91A-p-hnqQ.png" blogLink="https://medium.com/@jigyasaupadhyay60/build-backbone-application-with-webpack-b89b850a1b7f" title="Build Backbone Application with Webpack" />
                
            </div>
        </div>
        </>
    )
}

export default Blogs
